import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useNavigateWithPreviousRouteQueryParam = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: string) => {
      const prevParams = new URLSearchParams(location.search);
      const currentRouteWithParams = `${location.pathname}?${prevParams.toString()}`;

      const newParams = new URLSearchParams();
      newParams.set('previousRoute', currentRouteWithParams);

      navigate({
        pathname: to,
        search: newParams.toString(),
      });
    },
    [navigate, location],
  );
};
